var appGroupItems = {
  items: [
    {
      icon: "app-icon",
      label: "OHT",
      value: "WIRE_OSD"
    },
    {
      icon: "app-icon",
      label: "OSD",
      value: "WIRE_OHT"
    }
  ]
};

export default appGroupItems;
